import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconSignout: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.0176 8.06934C15.3934 7.66492 16.0261 7.64188 16.4307 8.01759L19.9307 11.2676C20.1343 11.4568 20.25 11.7221 20.25 12C20.25 12.2779 20.1343 12.5432 19.9307 12.7324L16.4307 15.9824C16.0261 16.3581 15.3934 16.3351 15.0176 15.9307C14.6419 15.5261 14.6649 14.8934 15.0693 14.5176L17.7803 12L15.0693 9.48243C14.6649 9.10659 14.6419 8.47396 15.0176 8.06934Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H10.75C10.1977 13 9.75 12.5523 9.75 12C9.75 11.4477 10.1977 11 10.75 11H19Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.75 17.25V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H15.25C15.8023 3.75 16.25 4.19772 16.25 4.75C16.25 5.30228 15.8023 5.75 15.25 5.75H6.75C6.19771 5.75 5.75 6.19771 5.75 6.75V17.25C5.75 17.8023 6.19771 18.25 6.75 18.25H15.25C15.8023 18.25 16.25 18.6977 16.25 19.25C16.25 19.8023 15.8023 20.25 15.25 20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25Z',
    })
  )
}
